import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import useAccessionColumns from "../../components/Accessions/useAccessionColumns";
import { DataGridComponent } from "../../components/common/DataGridComponent";
import { useAccessionDetails } from "../../components/Accessions/useAccessionDetails";
import { useNavigate } from "react-router-dom";

const Accessions: React.FunctionComponent<any> = () => {
  const navigate = useNavigate();
  const columns = useAccessionColumns();
  const { rowData } = useAccessionDetails();
  const actions = {
    accession_id: (data: any) => {
      navigate(`/accessions/${data?.accession_id}`);
    },
    studyID: (data: any) => {
      //   console.debug(data);
    },
    assessmentPlan: (data: any) => {
      //   console.debug(data);
    },
    actionsColumn: {
      action_edit: (data: any) => {
        // console.debug(data)
      },
      action_delete: (data: any) => (data: any) => {
        // console.debug(data)
      },
    },
  };
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs>
          <Typography variant="h4" gutterBottom>
            Accessions
          </Typography>
        </Grid>
        <Grid item justifyContent="flex-end">
          &nbsp;
        </Grid>
      </Grid>
      <Box sx={{ width: "100%", height: "calc(100vh - 160px)" }}>
        <DataGridComponent
          columns={columns as any}
          hasDefinedColumns={false}
          rows={rowData ?? []}
          showQuickFilter
          actions={actions}
        />
      </Box>
    </>
  );
};

export default Accessions;
